// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/scss/core/common.scss
// module id = 362
// module chunks = 50